const messages = {
  "ui.emailDynamicVariableView.someEntitiesMissingData.company":
    "Some companies are missing data for this variable",
  "ui.emailDynamicVariableView.someEntitiesMissingData.description":
    "When a variable is missing, it will show up blank.",
  "ui.emailDynamicVariableView.someEntitiesMissingData.ok": "Okay",
  "ui.emailDynamicVariableView.someEntitiesMissingData.person":
    "Some people are missing data for this variable",
} as const;

export default messages;
